import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_ADVERTISING}`;

const Advertising = {
  state: {
    listAdvertising: []
  },
  actions: {
    getAdvertisingForGame: async ({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAdvertisingForGame?gameId=${params.gameId}`)
        commit("SET_listAdvertising", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    createAdvertising: async ({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/createAdvertising`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    updateAdvertising: async ({}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/updateAdvertising`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getAdvertising: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAdvertising?id=${params.id}`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    deleteAdvertising: async ({}, params) => {
      try {
        const response = await Interceptor.delete(`${urlAPI}/deleteAdvertising?id=${params.id}`)
        return response;
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    SET_listAdvertising(state, value) {
      state.listAdvertising = value
    }
  }
};

export default Advertising;